import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import GeneralReducer from './GeneralReducer';
import BillerReducer from './BillerReducer';
import ServiceReducer from './ServiceReducer';
import formData from './FormReducer';
import InvoiceReducer from './InvoiceReducer';

const moduleState = {
  general: GeneralReducer,
  biller: BillerReducer,
  service: ServiceReducer,
  form: formReducer,
  formData,
  invoice: InvoiceReducer,
};

export default combineReducers(moduleState);
